export { SecretSourcesComponent } from './secret-sources.component'; 